import React, { Component } from 'react';

class FilterStepTitle extends Component {
	render() {
		if (this.props.text.length > 0)
		{
			return (
				<div className="filters__step-title">{this.props.text}</div>
			);
		}
		else
		{
			return null;
		}
	}
}

export default FilterStepTitle;
